import { Id, projectReport } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, reportId: Id) {
  return getState().find(({ report }) => report.uuid === reportId);
}

function queryState(getState: () => State, reportId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, reportId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectReportRequestFailure({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isFailure, false);
    },
    isRemoveProjectReportRequestPending({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isPending, false);
    },
    isRemoveProjectReportRequestSuccess({ uuid }) {
      return queryState(getState, uuid)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
  };
}

export { createSelector };
